/**
 * Created by omero on 18-May-17.
 */

/**
 * Created by omero on 06-Dec-16.
 */
import {Injectable, Inject} from 'ng-metadata/core';
import {SearchService} from "../search/search.service";
import {FullViewService} from "../search/fullView/fullView.service";
import {ConfigurationUtil} from '../nddUtils/configurationUtil.service';
var angular: angular.IAngularStatic = require('angular');




@Injectable()
export class FilterLanguage{

    constructor(private searchService:SearchService,
    		private fullViewService: FullViewService,
    		@Inject('$translate') private $translate: ng.translate.ITranslateService,
    		private configurationUtil: ConfigurationUtil) {

    }



    public fillterPnx(pnx){
        pnx.display.title = this.filterField( pnx.display.title);
        pnx.display.subject = this.filterField( pnx.display.subject);
        pnx.display.description = this.filterField( pnx.display.description);
        pnx.display.format = this.filterField( pnx.display.format);
        pnx.display.creator = this.filterField( pnx.display.creator);
        pnx.display.contributor = this.filterField( pnx.display.contributor);
        return pnx;

    }

    public filterField(field){
        if(!angular.isDefined(field)){
            return undefined;
        }
        if(typeof field  ==='string'){
            if(!this.checkLang(field)){
                return this.removeNotRelevantChars(field);
            }
            return ''

        }
        else{
            field = field.filter(elem => {return this.checkLang(elem)});
            field = field.map(elem => {return this.removeNotRelevantChars(elem)});
            return field;

        }

    }

    public checkLang(facetdisplay:string){
        let lang3= this.searchService.getResultObject().lang3 || this.fullViewService.lang3;
        let langLength = -3;
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
        	lang3 = this.$translate.use();
        	langLength = -2;
        }
        if(!angular.isDefined(facetdisplay)){
             return true;
        }
        if(facetdisplay.indexOf("$$8") == -1) {
            return true;

        }
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
        	let index = facetdisplay.indexOf("$$8");
        	let languages = facetdisplay.substring(index);
        	let langList = languages.split(",");
        	for (let lang of langList) {
        		if (lang.slice(langLength) === lang3) {
        			return true;
        		}
        	}
        } else {
            if(facetdisplay.slice(langLength) ==  lang3) {
                return true;
            }
        }
        return false;
    }


    public removeNotRelevantChars(facet:string):string{
        let $$8RegEx= /\$\$8\s*(.){3}/g;
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
        	$$8RegEx= /\$\$8\s*(.){2}/g;
        }
        return facet.replace($$8RegEx, '');
    }






}








// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/filterLanguage.service.ts